export var SocketEvent;
(function (SocketEvent) {
    SocketEvent["USER_CONNECTED"] = "userConnected";
    SocketEvent["CURRENT_USERS"] = "currentUsers";
    SocketEvent["USER_DISCONNECTED"] = "userDisconnect";
    SocketEvent["UPDATE_STATE"] = "updateState";
    SocketEvent["PLAYER_DIED"] = "playerDied";
})(SocketEvent || (SocketEvent = {}));
